import SearchResultElement from '@/models/SearchResultElement';

export default class HtmlDataHelper {
  public static isHidden(elem: HTMLElement) {
    return elem.style.display === 'none';
  }

  public static ariaHidden(elem: HTMLElement) {
    if (elem.parentElement?.parentElement?.hasAttribute('aria-hidden')) {
      return elem.parentElement?.parentElement?.getAttribute('aria-hidden');
    }
    return false;
  }

  public static elementInViewport(el: HTMLElement) {
    const position = el.getBoundingClientRect();
    let incrementForHeight = 0;
    if (window.innerHeight >= 400 && window.innerHeight < 600) {
      incrementForHeight = 20;
    }
    if (window.innerHeight >= 600 && window.innerHeight < 800) {
      incrementForHeight = 40;
    }

    if (window.innerHeight >= 800 && window.innerHeight < 1000) {
      incrementForHeight = 40;
    }

    // mobile
    if (window.innerHeight >= 800 && window.innerHeight < 1000 && window.innerWidth < 935) {
      incrementForHeight = 20;
    }

    if (window.innerHeight >= 1000 && window.innerHeight < 1200) {
      incrementForHeight = 75;
    }

    // tablets
    if (window.innerHeight >= 800 && window.innerHeight < 1200 && window.innerWidth < 935) {
      incrementForHeight = 5;
    }

    if (window.innerHeight >= 1200) {
      incrementForHeight = 5;
    }

    return (
      position.top >= 0
      && position.left >= 0
      && position.bottom <= (
        (window.innerHeight || document.documentElement.clientHeight) + incrementForHeight)
      && position.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  // eslint-disable-next-line class-methods-use-this
  public static isDeactivated(position: DOMRect) {
    return position.height < 1 && position.width < 1;
  }

  public static getProductData(element: HTMLElement) {
    return {
      name: this.getTileName(element),
      category: this.getCategory(element),
      list: this.getTileId(element),
      position: this.getTilePosition(element),
    };
  }

  public static getPromotionData(element: HTMLElement) {
    return {
      id: this.getTileId(element),
      name: this.getTileName(element),
      creative: this.getTileUrl(element),
      position: this.getTilePosition(element),
    };
  }

  // eslint-disable-next-line class-methods-use-this
  public static getCurrency() {
    return document.querySelector('main')?.dataset.currency || '';
  }


  public static getTileName(element: HTMLElement) {
    let name = `${this.getTileTitle(element)}`;
    if (element.getAttribute('href')!.indexOf('/configurator/') > -1
      || element.getAttribute('href')!.indexOf('/p/') > -1
      || element.getAttribute('data-type') === 'product') {
      name = `${this.getTileFc(element)}|${this.getTileTitle(element)}`;
    }
    return name;
  }

  // eslint-disable-next-line class-methods-use-this
  public static getTileTitle(element: HTMLElement) {
    return element.querySelector('.tile__headline')?.textContent?.trim() || '';
  }

  public static getTileId(element: HTMLElement) {
    return element.getAttribute('data-id') || '';
  }

  public static getTileFc(element: HTMLElement) {
    return element.getAttribute('data-fc') || '';
  }

  // eslint-disable-next-line class-methods-use-this
  public static getTileUrl(element: HTMLElement) {
    return element.getAttribute('href') || '';
  }

  public static createAnalyticsCategory(searchResultElement: SearchResultElement): string {
    const categories = [
      searchResultElement.categoryTop,
      searchResultElement.categoryHigh,
      searchResultElement.categoryMedium,
      searchResultElement.categoryLow,
    ];
    const uniqueCategories = [
      ...new Set(categories.filter((category: string) => category.length > 0)),
    ];

    return uniqueCategories.join('/');
  }

  // eslint-disable-next-line class-methods-use-this
  public static getCategory(element: HTMLElement) {
    return element.getAttribute('data-category');
  }

  // eslint-disable-next-line class-methods-use-this
  public static getTilePosition(element: HTMLElement) {
    return element.getAttribute('data-increment');
  }

  // eslint-disable-next-line class-methods-use-this
  public static clearHtml() {
    document.querySelectorAll('a.search-result').forEach((elem) => {
      elem.removeAttribute('data-increment');
      elem.removeAttribute('data-sent');
    });
  }
}
